import { render, staticRenderFns } from "./DataTemplate.vue?vue&type=template&id=f0a25d54&scoped=true&"
import script from "./DataTemplate.vue?vue&type=script&lang=js&"
export * from "./DataTemplate.vue?vue&type=script&lang=js&"
import style0 from "./DataTemplate.vue?vue&type=style&index=0&id=f0a25d54&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0a25d54",
  null
  
)

export default component.exports